/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSuggestedReordersRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetSuggestedReordersResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getSuggestedReorders = (request: GetSuggestedReordersRequest, options?: CashRequestOptions) => post<GetSuggestedReordersRequest, GetSuggestedReordersResponse>("/2.0/cash/get-suggested-reorders", request, {...options, rejectOnError: true })